<form [formGroup]="cargueForm" class="card">

  <div class="card-header">
    <b>Carga de presupuesto</b>
  </div>

  <div class="card-body" style="margin-right: -5px; display: flex; justify-content: space-between; gap: 10px;">

    <div class="col-md-6 col-12">
      <button type="button" style="margin-bottom: 21.5px; padding: 0px 15px;" mat-button class="secondary w-100"
        (click)="inputFile.click()">
        Selecionar archivo
      </button>
      <input type="file" accept=".csv" (change)="onSelectFile(inputFile)" #inputFile hidden />
    </div>


    <div class="col-md-6 col-12">
      <div class="d-inline-flex justify-content-between">
        <button [disabled]="!isFileLoaded" (click)="onSubmit()" mat-button class="primary mb-3 mr-1">
          Subir Archivo
        </button>
      </div>
    </div>

  </div>

  <div class="card-header m-1 d-flex align-items-center flex-wrap" style="gap: 1rem;">
    <h2 class="m-1 mr-2">
      Reporte de presupuesto
    </h2>
  </div>
 

  <div [formGroup]="cargueForm">
    <div class="card-body row" style="justify-content: center;">

      <mat-form-field appearance="fill" class="col-12 col-md-3">
        <mat-label>Periodo:</mat-label>
        <input [disabled]="!isProcesar" matInput [matDatepicker]="pickerPeriodo" placeholder="Selecciona un periodo"
          (dateChange)="selectedDateChangedPeriodo($event)">
        <mat-datepicker-toggle matSuffix [for]="pickerPeriodo"></mat-datepicker-toggle>
        <mat-datepicker #pickerPeriodo></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill" class="col-12 col-md-3">
        <mat-label>Fecha inicio:</mat-label>
        <input [disabled]="!isProcesar" matInput [matDatepicker]="pickerInicio" placeholder="Selecciona una fecha"
          (dateChange)="selectedDateChangedInicio($event)">
        <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
        <mat-datepicker #pickerInicio></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill" class="col-12 col-md-3">
        <mat-label>Fecha fin:</mat-label>
        <input [disabled]="!isProcesar" matInput [matDatepicker]="pickerFin" placeholder="Selecciona una fecha"
          (dateChange)="selectedDateChangedFin($event)">
        <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
        <mat-datepicker #pickerFin></mat-datepicker>
      </mat-form-field>

    </div>
  </div>
  

  <div class="container-fluid">
    <div class="card text-center">
      <div class="card-body">
        <h5 class="card-title">Dale clic para comenzar a Procesar!</h5>
        <div class="row">
          <div class="col-3"></div>
          <div class="col-6  text-center">
            <button [disabled]="!isProcesar" mat-button type="button" class="secondary" (click)="procesarArchivo()">
              Procesar archivo
            </button>
          </div>
          <div class="col-3"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer gap-1">
  </div>
</form>